/**
 * Admin Google Calendar API client (PR2 mock-only).
 *
 * Vive en archivo aparte de `client.ts` para no exceder el limite de
 * `max-lines` de ESLint en aquel.
 */
import { apiFetch } from './client';

export interface GoogleStatus {
  connected: boolean;
  ownerType?: 'user' | 'center';
  ownerId?: string;
  calendarId?: string;
  connectedAt?: string;
}

export const adminGoogleApi = {
  status: (ownerType: 'user' | 'center', ownerId: string) =>
    apiFetch<GoogleStatus>(
      `/api/admin/google/status?owner_type=${ownerType}&owner_id=${encodeURIComponent(ownerId)}`,
    ),
  connect: (ownerType: 'user' | 'center', ownerId: string) =>
    apiFetch<{ authUrl: string; mock: boolean }>('/api/admin/google/connect', {
      method: 'POST',
      body: JSON.stringify({ ownerType, ownerId }),
    }),
  /** En modo mock, completa el OAuth inmediatamente sin navegar a Google. */
  completeMock: (ownerType: 'user' | 'center', ownerId: string) =>
    apiFetch<{ connected: boolean; ownerType: string; ownerId: string }>(
      `/api/admin/google/callback?owner_type=${ownerType}&owner_id=${encodeURIComponent(ownerId)}`,
    ),
  disconnect: (ownerType: 'user' | 'center', ownerId: string) =>
    apiFetch<{ disconnected: boolean }>(
      `/api/admin/google/disconnect?owner_type=${ownerType}&owner_id=${encodeURIComponent(ownerId)}`,
      { method: 'DELETE' },
    ),
};
